"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumPortNamingRule = void 0;
const AltiumNetNamingRule_1 = require("./AltiumNetNamingRule");
const AltiumNetNameCaseSelection_1 = require("./AltiumNetNameCaseSelection");
const AltiumNetNamingStrategy_1 = require("./AltiumNetNamingStrategy");
class AltiumPortNamingRule extends AltiumNetNamingRule_1.AltiumNetNamingRule {
    apply(group, _hierarchy) {
        if (!this.config.allowPortNetNames) {
            return undefined;
        }
        if (!group.hasLabelType('port')) {
            return undefined;
        }
        const portNames = [];
        for (const [instance, nets] of group.getNets()) {
            for (const net of nets) {
                for (const label of net.labels) {
                    if (label.labelType !== 'port') {
                        continue;
                    }
                    const name = (0, AltiumNetNamingStrategy_1.appliesChannelNetFormatting)(instance) && label.formattedLabel ? label.formattedLabel : label.originalLabel;
                    portNames.push(this.dereferenceLabelName(name));
                }
            }
        }
        if (portNames.length === 0) {
            return undefined;
        }
        portNames.sort(AltiumNetNameCaseSelection_1.compareAltiumNetNameCandidates);
        return this.dereferenceLabelName(portNames[0]);
    }
}
exports.AltiumPortNamingRule = AltiumPortNamingRule;
//# sourceMappingURL=AltiumPortNamingRule.js.map